
import React from 'react';
import '../Style/ECUDeploymentStatus.css';
import { Link, useNavigate } from 'react-router-dom'; 
import { useQuery } from '@tanstack/react-query'; 

const API_BASE_URL = "https://api.yellowmatrix.co.in"; 

const ECUDeploymentStatus = () => {
  const navigate = useNavigate();

  const { data: rollouts = [], isLoading: loading } = useQuery({
    queryKey: ['ecuRollouts'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/ecu-fota`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) throw new Error("Failed to fetch rollouts");
      return response.json();
    },
    refetchInterval: 10000, 
  });

  return (
    <div className="ECU-main-container">
      <div className="ECU-header">
        <h1 className="ECU-header-title">ECU Deployment Status</h1>
        <p className="ECU-">Manage And Monitor Your Firmware Rollouts</p>
        <hr className="ECU-horizantal-line"></hr>
      </div>
      <div className="ECU-device-firmware-table">
        <table className="ECU-device-table">
          <thead>
            <tr className="ECU-table-headers-row">
              <th>Device Group</th>
              <th>Version</th>
              <th>Customer</th>
              <th>Total</th>
              <th>Success</th>
              <th>Failed</th>
              <th>Type</th>
              <th>Status</th>
              <th>Action</th> 
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="9" style={{textAlign: 'center', color: '#334155'}}>Loading...</td></tr>
            ) : rollouts.length === 0 ? (
              <tr><td colSpan="9" style={{textAlign: 'center', color: '#334155'}}>No rollouts found.</td></tr>
            ) : (
              rollouts.map((rollout) => (
                <tr className="ECU-device-data" key={rollout.id}>
                  <td>{rollout.deviceGroup}</td>
                  <td>{rollout.version}</td>
                  <td>{rollout.customer}</td>
                  <td>{rollout.deviceCount}</td>
                  <td>{rollout.successDevice}</td>
                  <td>{rollout.failedDevice}</td>
                  <td>Update</td>
                  <td>
                    <span className={`ECU-device-update ${rollout.status ? rollout.status.toLowerCase() : ''}`}>
                      {rollout.status}
                    </span>
                  </td>
                  <td className="ECU-deployment-status-link">
                    {/* If failed, show "New Rollout" button, else "View Details" */}
                    {rollout.status?.toLowerCase() === "failed" ? (
                      <button className="ECU-new-rollout-button"
                        onClick={() => navigate('/RollOut', { state: { retryData: rollout } })}
                        style={{ 
                          background: 'none', 
                          border: 'none', 
                          color: '#e6852b', 
                          cursor: 'pointer', 
                          padding: 0, 
                          fontWeight: 600,
                          font: 'inherit', 

                          // textDecoration: 'underline' 
                          
                        }}
                      >
                        Retry
                      </button>
                    ) : (
                      <Link to={`/ECUFotaDeploymentStatus/${rollout.id}`}>View Details</Link>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>    
      </div>
    </div>
  );
}

export default ECUDeploymentStatus;